import { render, staticRenderFns } from "./ManageColumns.vue?vue&type=template&id=1410d9d8&"
import script from "./ManageColumns.vue?vue&type=script&lang=js&"
export * from "./ManageColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports